// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  createPriceBook,
  deletePriceBook,
  getPriceBookDetail,
  getPriceBookList,
  updatePriceBook,
} from './priceBookThunk';

export interface IPriceBookState {
  isRefreshPriceBookList: boolean;
}

export const initialState: IPriceBookState = {
  isRefreshPriceBookList: false,
};

const priceBookSlice = createSlice({
  name: 'priceBook',
  initialState,
  reducers: {
    setRefreshPriceBookList: (state, action) => {
      state.isRefreshPriceBookList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET: Get price book list
    builder
      .addCase(getPriceBookList.pending, (_state) => {})
      .addCase(getPriceBookList.fulfilled, (_state) => {})
      .addCase(getPriceBookList.rejected, (_state) => {});

    // POST: Create price book
    builder
      .addCase(createPriceBook.pending, (_state) => {})
      .addCase(createPriceBook.fulfilled, (_state) => {})
      .addCase(createPriceBook.rejected, (_state) => {});

    // GET: Get price book detail
    builder
      .addCase(getPriceBookDetail.pending, (_state) => {})
      .addCase(getPriceBookDetail.fulfilled, (_state) => {})
      .addCase(getPriceBookDetail.rejected, (_state) => {});

    // PUT: Update price book
    builder
      .addCase(updatePriceBook.pending, (_state) => {})
      .addCase(updatePriceBook.fulfilled, (_state) => {})
      .addCase(updatePriceBook.rejected, (_state) => {});

    // DELETE: Delete price book
    builder
      .addCase(deletePriceBook.pending, (_state) => {})
      .addCase(deletePriceBook.fulfilled, (_state) => {})
      .addCase(deletePriceBook.rejected, (_state) => {});
  },
});

// Action
export const priceBookActions = priceBookSlice.actions;

// Selectors
export const selectIsRefreshPriceBookList = (state: RootState) => state.priceBook.isRefreshPriceBookList;

// Reducer
const priceBookReducer = priceBookSlice.reducer;
export default priceBookReducer;
